/*
Rods

  --diameter <float::enum> | inches | ['6 1/16th', '6 5/16th']
  --length <float> | inches
*/
import { diameter, length } from '@/modules/standardItems/schemas/baseFilters'
import hardwareFilters from '@/modules/standardItems/schemas/hardware/filters'

export default [
  ...hardwareFilters,
  diameter(),
  length()
]
